<template>
  <div class="teams">
    <div class="nav">
      <router-link class="team button blue bold larger box" v-for="team in displayTeams" v-bind:to="link(team)"
                   v-bind:key="team.key">
        {{team.name}}
      </router-link>
    </div>
    <router-view/>
    <match/>
  </div>
</template>

<script>
  /*
  */
  //const REQ = process.env.VUE_APP_API_REQ
  //const TEAMS = process.env.VUE_APP_HOST + process.env.VUE_APP_TEAMS.replace(/&/g, "%26")
  //const READ_API = REQ + "?value=" + TEAMS + "&cache=no"
  //const READ_API = TEAMS
  import EventService from "@/services/event.service";

  const parser = new DOMParser();
  const def = [{name: "1A"}, {name: "1B"}, {name: "1C"}, {name: "1D"}, {name: "U19 A"}, {name: "U17 A"}, {name: "U17 B"}, {name: "U15 A"}, {name: "U15 B"}, {name: "U15 F"}, {name: "U15 F 2"}
    /*, {name: "U15 F 3"}*/
    , {name: "U13 F"}, {name: "U13 A"}, {name: "U13 B"}]

  import TeamService from '../../services/team.service'
  import Match from '../home/Match.vue'
  import helper from '../../helper'

  export default {
    name: 'Teams',
    components: {
      Match
    },
    created() {
      //console.log("READ_API", READ_API);
      // this.competition = {};
      // this.$root.$data.competition.all()
      //   .then(competition => {
      //     //console.log(competition)
      //     this.competition = competition
      //   })
      return this.getTeams()
        .then(this.read)
        //.get("data")
        .then(this.parseTeam)
        .tap(this.save)
        .then(this.complete)
    },
    data() {
      return {
        teams_: [],
        teams: [],
        displayTeams: []
      }
    },
    methods: {
      link(team) {
        return "/teams/" + team.name;
      },
      getTeams() {
        return TeamService.getTeams()
          //.tap(teams => console.log(teams))
          .tap(teams => this.teams_ = teams)
          .tap(teams => this.teams = _.sortBy(_.cloneDeep(teams), t => _.indexOf(_.map(def, "name"), t.name)))
      },
      read() {
        //debugger;
        //const promise = this.axios.get(READ_API, {  headers: {
        //    'Content-Type': 'application/json;charset=UTF-8'
        //  }})
        // promise.then(resp => {
        //   const result = resp.data.toString('ISO-8859-1');
        //   return {data: result}
        // })
        const promise = EventService.getTeams()
        return promise;
      },
      parseTeam(html) {
        const doc = parser.parseFromString(html, "text/html");
        const query = doc.body.querySelectorAll(".calendrier-content a")
        _.map(this.teams_, t => t.events = [])
        return _.filter(_.map(query, t => {
          const event = t.innerText.trim()
          const eventKey = _.kebabCase(event)
          //console.log(_.kebabCase(event))
          //const name = _.get(this.competition, _.kebabCase(event), _.kebabCase(event))
          const name = TeamService.teamByEvent(eventKey)
          let key = _.kebabCase(name);
          let team = _.find(this.teams_, {key})
          if (_.isNil(team)) {
            if (!_.includes(eventKey, "matchs-amicaux")
                && !_.includes(eventKey, "regional-3-equipe-2")
                /*&& !_.includes(eventKey, "konica")*/
            ) {
              console.warn(key, eventKey)
              //debugger
            }
          } else {
            const evt = {event}
            _.map(_.split(t.href, "&"), p => {
              const a = p.split("=")
              _.set(evt, a[0], a[1])
            })
            team && team.events.push(_.pick(evt, ["event", "label", "competition", "group", "stage"]))
          }
          return team
        }), t => t)
      },
      save(teams) {
        return this.$root.$data.team.save(teams)
      },
      complete() {
        //this.teams = _.sortBy(_.uniqBy(helper.push(this.teams, def), "name"), t => _.indexOf(_.map(def, "name"), t.name))
        const teams = _.sortBy(_.uniqBy(helper.push(this.teams, def), "name"), t => _.indexOf(_.map(def, "name"), t.name))
        this.displayTeams = _.filter(teams, t => _.includes(_.map(def, "name"), t.name))
        this.emptyTeams = _.filter(teams, t => !_.includes(_.map(def, "name"), t.name))
        _.map(this.emptyTeams, t => console.log( _.kebabCase(_.get(t, "events.0.event"))))
      }
    }
  }

</script>

<style scoped lang="stylus">
  .teams
    .match
      margin-top: 10px;
    .nav
      line-height 50px
      @media screen and (max-width: 960px)
        line-height 45px
        .button
          font-size medium !important
          padding 5px 8px !important
          margin 2px
</style>